function isBrowser(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined'
  );
}

export const isClient = isBrowser();

export const isServer = !isClient;

export const isContainerQueryFallback = isClient && !CSS.supports('container-type', 'inline-size');

export const isSafari =
  isClient && /Safari/i.test(navigator.userAgent) && navigator.userAgent.includes('Version/');

export const isOldSafari =
  isSafari &&
  (() => {
    const version = navigator.userAgent.split('Version/')?.[1]?.split(' ')?.[0] ?? '';
    const [major, minor] = version.split('.');
    if (major && minor) {
      const majorNumber = parseInt(major, 10);
      const minorNumber = parseInt(minor, 10);
      if (majorNumber > 18 || (majorNumber === 18 && minorNumber >= 4)) {
        return false;
      }
    }
    return true;
  })();
